import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
//스텝 렌더 컴포넌트
export const Step = (param)=>{
    let { condition , children  } = param;
    if (condition) return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
    return /*#__PURE__*/ _jsx(_Fragment, {});
};
